import Component from '../vendor/Component'

export default class CartDrawerUpsells extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)

    this._galleryElement = this._elem.querySelector('[data-cart-drawer-upsells-el="swiper"]')
  }

  mount() {
    this.initCarousel()
  }

  initCarousel() {
    if (this._galleryElement) {
      new window.swiper(this._galleryElement, {
        spaceBetween: 5,
        slidesPerView: 2.4,
        loop: false,
        navigation: {
          nextEl: '[data-cart-drawer-upsells-el="next"]',
          prevEl: '[data-cart-drawer-upsells-el="prev"]',
        },
      });
    }
  }
}
